import React, { Component } from 'react'
import Header from '../Header'
import './XXIIIw.css'

class XXIIIw extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyXXIIIw">
                    <p className="textXXIIIw">A venir...</p>
                </div>
            </div>
        )
    }
}

export default XXIIIw